import React, { Component } from 'react';
import InputField from '../../components/inputs/inputField';
import SelectField from '../../components/inputs/selectField';
import CustomStyling from '../../sections/event/pages/customStyling';

class AccountDetails extends Component {
	constructor(props) {
		super(props);
		const { orgId } = props;
		this.state = {};
	}

	render() {
		const {
			name,
			identifier,
			hostname,
			branding,
			adminEmail,
			adminEmailName,
			defaultRedirect,
			defaultUserPath,
			defaultPublicPath,
		} = this.props.accountData;
		const publicPathOptions = this.props.accountData.orgPages
			.map((po) => {
				if (po.openToPublic) return { label: po.title, value: po.pathSlug };
			})
			.filter((p) => !!p);
		const privatePathOptions = this.props.accountData.orgPages.map((po) => {
			return { label: po.title, value: po.pathSlug };
		});
		let publicPath = publicPathOptions.find((path) => path.value == defaultPublicPath);
		let privatePath = privatePathOptions.find((path) => path.value == defaultUserPath);

		let selectedSection = this.props.selectedIndexA;
		const { orgId } = this.props;

		return (
			<div className="sectionContainer mt-20 " >
				<div className="sectionBody h-100">
					<div className="flex h-100">
						<div className="sectionBlock" style={{ maxHeight: '100%', overflowX: 'hidden', paddingRight: 5 }} >
							{selectedSection == 0 && <div>
								<h2 className='mb-20  semibold'>Account</h2>
								<InputField
									label="Account Name"
									type="text"
									value={name}
									disabled={true}
									inputIcon={<i className="las la-lock lightGray" />}
								/>
								<InputField
									label="Platform Address"
									type="text"
									value={`${identifier}.simple.events`}
									disabled={true}
									inputIcon={<i className="las la-lock lightGray" />}
								/>
								<InputField
									label="Custom Web Address"
									type="text"
									value={hostname}
									disabled={true}
									inputIcon={<i className="las la-lock lightGray" />}
								/>
								<h2 className="mb-20 mt-20 semibold">Support</h2>
								<InputField
									label="Support Name"
									type="text"
									value={branding.accountName}
									onChange={(e) => {
										this.props.editAccountData({
											...this.props.accountData,
											branding: {
												...this.props.accountData.branding,
												accountName: e.target.value
											}
										});
									}}
								/>
								<InputField
									label="Support Email"
									type="text"
									value={branding.supportEmail}
									onChange={(e) => {
										this.props.editAccountData({
											...this.props.accountData,
											branding: {
												...this.props.accountData.branding,
												supportEmail: e.target.value
											}
										});
									}}
								/>

								<h2 className="mb-20 mt-20 semibold">Emails</h2>
								<InputField
									label="Default From  Name"
									type="text"
									value={adminEmailName}
									onChange={(e) => {
										this.props.editAccountData({
											...this.props.accountData,
											adminEmailName: e.target.value
										});
									}}
								/>
								<InputField
									label="Default From Email"
									type="text"
									value={adminEmail}
									onChange={(e) => {
										this.props.editAccountData({
											...this.props.accountData,
											adminEmail: e.target.value
										});
									}}
								/>

							</div>}
							{selectedSection == 1 && <div>
								<h2 className="mb-20 semibold">Setup</h2>
								<SelectField
									label="Public Home Page"
									value={publicPath ? publicPath : { label: '', value: '' }}
									name="defaultUserPath"
									options={publicPathOptions}
									onChange={(path) => {
										this.props.editAccountData({
											...this.props.accountData,
											defaultPublicPath: path.value
										});
									}}
								/>
								<SelectField
									label="Private Home Page"
									value={privatePath ? privatePath : { label: '', value: '' }}
									name="defaultUserPath"
									options={privatePathOptions}
									onChange={(path) => {
										this.props.editAccountData({
											...this.props.accountData,
											defaultUserPath: path.value
										});
									}}
								/>
							</div>}
							{selectedSection == 2 && <div>
								<h2 className="mb-20 semibold">Tracking</h2>
								<InputField
									label="Google Analytics Code"
									type="text"
									value={branding.googleId}
									onChange={(e) => {
										this.props.editAccountData({
											...this.props.accountData,
											branding: {
												...this.props.accountData.branding,
												googleId: e.target.value
											}
										});
									}}
								/>
								<InputField
									label="Default Redirect"
									type="text"
									prefix={hostname && hostname != '' ? `${hostname}/` : `${identifier}.simple.events`}
									value={defaultRedirect}
									onChange={(e) => {
										this.props.editAccountData({
											...this.props.accountData,
											defaultRedirect: e.target.value
										});
									}}
								/>
								<h2 className="blockHeader mt-20">Custom Header Scripts</h2>
								<p className="mb-20">
									The code here will be applied in the {"<head>"} tag of all
									the pages within the organization.
								</p>
								<CustomStyling
									key="customHeader"
									style={{ minHeight: 100 }}
									eventCustomCSS={branding.headTagScripts || ''}
									updateStyling={(header) => {
										this.props.editAccountData({
											...this.props.accountData,
											branding: {
												...this.props.accountData.branding,
												headTagScripts: header
											}
										});
									}}
									readOnly={this.props.readOnly}
									language="html"
								/>

								<h2 className="blockHeader mt-20">Custom Body Scripts</h2>
								<p className="mb-20">
									The code here will be applied in the {"<body>"} tag of all
									the pages within the organization.
								</p>
								<CustomStyling
									key="customBody"
									style={{ minHeight: 100 }}
									eventCustomCSS={branding.bodyTagScripts || ''}
									updateStyling={(bodyScripts) => {
										this.props.editAccountData({
											...this.props.accountData,
											branding: {
												...this.props.accountData.branding,
												bodyTagScripts: bodyScripts
											}
										});
									}}
									readOnly={this.props.readOnly}
									language="html"
								/>
							</div>}
						</div>
					</div>
				</div>
			</div>
		);
	}
}
export default AccountDetails;
